import API from "./axios"
import { getUserInfo, getResetTokenInfo } from "../utils/authDecode"

export async function getUserProfiles() {
  const { data } = await API.get("/v1/user-profiles")
  return data.data
}

export async function updateUserProfile(updates) {
  const { data } = await API.patch("/v1/user-profiles", updates)
  return data.data
}

export async function createUserProfile(payload) {
  const { data } = await API.post("/v1/user-profiles", payload)
  return data.data
}

export async function updateUserEmail(email) {
  const userInfo = getUserInfo()
  if (!userInfo?.user_id) {
    throw new Error("No user_id found in token")
  }

  const { data } = await API.patch(`/v1/users/${userInfo.user_id}`, { email })
  return data.data
}

export async function updateUserPassword(payload) {
  const userInfo = getUserInfo() || getResetTokenInfo()
  if (!userInfo?.user_id) {
    throw new Error("No user_id found in token")
  }

  const { data } = await API.patch(`/v1/users/${userInfo.user_id}`, payload)
  return data.data
}

export const updateUserProfileImage = async (
  userId,
  file,
  firstName,
  lastName,
) => {
  try {
    const formData = new FormData()
    formData.append("id", userId)
    formData.append("image_profile_url", file)
    formData.append("first_name", firstName)
    formData.append("last_name", lastName)
    const response = await API.patch("/v1/user-profiles", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    return response.data
  } catch (error) {
    console.error("Upload failed:", error)
    throw error
  }
}
